import { API } from "src/constants";

import { Http } from "../http";

import { PageResponse } from "./pages.types";

export const getPageContent = (url: string): PageResponse =>
  Http.get(`${API}/${url}`);
